import http from "../../utils/http"

/**
 * 获取用户信息
 * @param {object} params
 */
export function info(params) {
    return http({
        url: "/api/member/info",
        data: params,
        forceLogin: true
    })
}
/**
 * 获取代客下单绑定信息
 * @param {object} params
 */
export function getAgent(params) {
    return http({
        url: "/staff/api/salesmanAgent/getAgent",
        data: params,
        forceLogin: true
    })
}
/**
 * 获取代客下单绑定客户列表
 * @param {object} params
 */
export function getSalesmanAgent(params) {
    return http({
        url: "/staff/api/salesmanAgent/memberList",
        data: params,
        forceLogin: true
    })
}
/**
 * 切换代客下单绑定客户
 * @param {object} params
 */
export function changeSalesmanAgent(params) {
    return http({
        url: "/staff/api/salesmanAgent/changeMember",
        data: params,
        forceLogin: true
    })
}

/**
 * 修改昵称
 * @param {object} params
 */
export function nickName(params) {
    return http({
        url: "/api/member/modifynickname",
        data: params,
        forceLogin: true
    })
}
/**
 * 修改头像
 * @param {object} params
 */
export function headImg(params) {
    return http({
        url: "/api/member/modifyheadimg",
        data: params,
        forceLogin: true
    })
}
export function qualificationConfig() {
    return http({
        url: "/api/qualification/getQualificationConfig",
    })
}
export function qualificationUpload(params) {
    return http({
        url: "/api/qualification/qualificationUpload",
        data:params,
        forceLogin: true
    })
}
export function memberQualification() {
    return http({
        url: "/api/qualification/getMemberQualification",
        forceLogin: true
    })
}
